import React, { Component } from "react"
import Responsive from "react-responsive"
import { observer } from "mobx-react"
import { Button, Container, Dropdown, Icon, Menu, Modal, Image } from "semantic-ui-react"
import { Link, NavLink } from "react-router-dom"
import CartButton from "components/Cart/CartButton"
import shop from "shop/shop"

import MenuBySlug from "components/Menu/MenuBySlug"
import queryString from "qs"
import languageStore from "stores/languageStore"
import app from "app.controller"
import "style/header.scss"
import searchStore from "stores/searchStore"
import { SearchForm } from "components/Search/SearchBarWithOptions"
import { withRouter } from "react-router"


// import Navigation from "../Navigation/Navigation"
@observer
export default class Header extends Component {

	constructor() {
		super()
		this.state = {
			list: shop.orderlist.default,
			categoryData: false
		}
	}

	componentDidMount() {
		shop.events.loaded.add( this.handleLoad )
		shop.orderlist.default.events.change.add( this.handleOrderlist )
	}

	handleOrderlist = ( {list} ) => {
		this.setState( {
			list
		} )
	}

	handleLoad = () => {
		this.setState( {
			categoryData: shop.categories
		} )
	}

	componentWillUnmount() {
		shop.orderlist.default.events.change.remove( this.handleOrderlist )
		shop.events.loaded.remove( this.handleLoad )
	}

	render() {
		const {showMini} = this.state
		const categories = shop.categories
		return (
			
			<header className={`header ${showMini}`}>
				<Responsive maxWidth={790}>
					<div>
						{showMini && <MiniHeaderMobile/>}
						<OnOffset
							offset={95}
							onPassedReverse={() => {
								this.setState( {showMini: false} )
							}}
							onPassed={() => {
								console.log( "scrolled" )
								this.setState( {showMini: "scrolled"} )
							}}>
							<MobileHeader/>
						</OnOffset>
					</div>
				</Responsive>
				<Responsive minWidth={790}>
					<div>
						{showMini && <MiniHeader/>}
						<OnOffset
							offset={95}
							onPassedReverse={() => {
								this.setState( {showMini: false} )
							}}
							onPassed={() => {
								console.log( "scrolled" )
								this.setState( {showMini: "scrolled"} )
							}}>
							<DesktopHeader/>
						</OnOffset>
					</div>
				</Responsive>
				{/*				<Container><div className="overflowContainer">
				<nav className="categoryHeaderMenu">{categories.map(category => {
					return <Link className="dib f5 pr2 pa3" key={category.map_id} to={`/collection/${category.map_id}/`}>
					<div className="catDescDiv">{category.desc.des}</div></Link>
				})}</nav></div></Container> */}
				
			</header>
		)
	}
}

class MobileHeader extends Component {
  render() {
    const { inverted = false } = this.props
    return (
      <div className="MobileHeader ">
        <div className="pa1 ph2 ph2-ns pt3-ns pb3-ns">
          <div className="flex flex-row justify-between items-center ">
            <div className={"w-70 flex flex-row justify-start pr4 pb3 pt3"}>
              <Button className="ButtonFooter" as="div"><Icon className="IconCss" onClick={app.sidebarLeft.toggle.dispatch} name="big bars" /></Button>
              {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&
              <Button className="ButtonFooter" as={Link} to={`/account/?referrer=${document.location.pathname}`}><Icon className="IconCss" name="big user circle" /></Button>}
              {((!shop.session) || (shop.session && shop.session.shopuser && shop.session.shopuser.guest)) &&
              <Button className="ButtonFooter" as={Link} to={`/login/?referrer=${document.location.pathname}`}><Icon className="IconCss"  name="big user circle" /></Button>}
            </div>
            
            <div className={"w-100 flex flex-row items-center justify-center"}>
              <Image as={Link} to={"/"} src={"/Logo_JohannesLucht_gruen.png"} />
            </div>
            
            <div className={"w-70 flex flex-row justify-end items-center pr4 pb3 pt3"}>
              {/*<Search />*/}
              <Button className="ButtonFooter" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
              <Button className="ButtonFooter" as={Link} to={`/checkout/?referrer=${document.location.pathname}`}><Icon className="IconCss" name="big shopping cart" /></Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


const SettingsModal = ( {inverted} ) => {
	return (
		<Modal trigger={<Button basic inverted={inverted} icon="settings"/>}>
			<Modal.Content>
				<SettingsMenu vertical/>
			</Modal.Content>
		</Modal>
	)
}


const SettingsMenu = observer(
	( props ) => {
		const {currentLanguage} = languageStore
		return (
			<Menu secondary
						borderless
						fluid
						{...props}
						size="mini">

				{/* LEFT SIDE MENU */}
				{shop.session && <Menu.Item
					position="right"
					as={Link}
					to="/orderlist/">{translate( "Orderlist" )}</Menu.Item>}

				{/* RIGHT SIDE MENU*/}
				{( shop.session && shop.session.handId ) && <Menu.Item
					as={Link}
					to="/login/accounts/">{translate( "Clients" )}</Menu.Item>}
				{shop.session && <Menu.Item
					as={Link}
					to="/quickorder/">{translate( "Quickorder" )}</Menu.Item>}

				{shop.session && <Menu.Item
					as={Link}
					to="/account/">{translate( "My Account" )}</Menu.Item>}
				{shop.session && <Menu.Item
					as={Link}
					to="/logout/">{translate( "Logout" )}</Menu.Item>}

				{!shop.session && <Menu.Item
					position="right"
					as={Link}
					to="/login/">{translate( "Anmelden" )}</Menu.Item>}
				{languageStore.available.length > 1 && <Dropdown text={currentLanguage.toUpperCase()}
																												 pointing
																												 className="link item">
					<Dropdown.Menu>
						{languageStore.available.map( locale => <Dropdown.Item
							key={locale}
							onClick={() => languageStore.setLanguage( locale )}>{locale}</Dropdown.Item> )}
					</Dropdown.Menu>
				</Dropdown>}
			</Menu>
		)
	}
)


@observer
@withRouter
class DesktopHeader extends Component {
	render() {
		let ItemsInCart = 0;
		if(shop.session){
			console.log("shop.cart.items", shop.cart.size);
			ItemsInCart = shop.cart.size;
		}
		return (
			<div>
				{/*				<div className="top-menu-mini absolute top-0 left-0 right-0 z-3">
					<Container><SettingsMenu /></Container>
				</div> */}

				<OnOffset
					offset={95}
					onPassedReverse={() => {
						this.setState( {showMini: false} )
					}}
					onPassed={() => {
						this.setState( {showMini: "scrolled"} )
					}}>
					<div className="top-menu pa3">
						<Container className="relative">
							<div className="absolute left-1 top-0 bottom-0">
								{/*<Responsive maxWidth={1298}><Button icon="bars" onClick={app.sidebarLeft.toggle.dispatch}/></Responsive>*/}
								<NavLink to="/" className={"Logo"}>
									<img
										src={"/Logo_JohannesLucht_gruen.png"}
										alt="zur Startseite"/>
								</NavLink>
								{/*<Button basic> DE <Icon name="caret down"/></Button>*/}
							</div>

							{console.log("shop.config", shop.config)}
							<div className="absolute right-0 top-0 mt1">
								<MenuBySlug
									key={"mini-header"}
									slug={"header"}
									secondary
									borderless>
									{<Menu.Item><Link to="/collection/"><p className="f4 fw5 black-60">SHOP</p></Link></Menu.Item>}
									{<Menu.Item><Link to="/cms/sortiment"><p className="f4 fw5 black-60">SORTIMENT</p></Link></Menu.Item>}
									{<Menu.Item><Link to="/cms/about"><p className="f4 fw5 black-60">ÜBER UNS</p></Link> </Menu.Item>}
									{<Menu.Item><Link to="/customer_contact"><p className="f4 fw5 black-60">KONTAKT</p></Link></Menu.Item>}
									{/*{!shop.session && <Menu.Item className={"primary"} as={Link} to={"/login/"}>{translate( "Anmelden" )}</Menu.Item>}
									{!shop.session && <Menu.Item as={Link} to={"/customer_registration/"}>{translate( "Registrieren" )}</Menu.Item>} */}

									{/*{shop.session && <Menu.Item><CartButton/></Menu.Item>}*/}
									{/*<Menu.Item  className={"no-highlight"}>
										<div className="flex flex-row items-center">
											<SearchForm
												style={{width: "170px"}}
												className={"mw6 w-100"}
												value={searchStore.searchTerm} onChange={e => {
												searchStore.setSearchTerm( e.target.value )
											}} icon="search" placeholder={translate("Suche")+"..."}/>
										</div>
									</Menu.Item> */}
									{<Menu.Item><p className="f2 black-10">|</p></Menu.Item>}
									<Menu.Item
										as={Link}
										to="/search/"><Icon name="big grey search"/></Menu.Item>
								{shop.session && <Menu.Item className="relative"
										as={Link}
										{...this.props}
										to={{
											pathname: `/checkout/`,
											search  : queryString.stringify( {referer: document.location.pathname} )
										}}><Icon name="big grey shopping cart"/>
													<div
														style={{
														position: "absolute",
														top: "0",
														right: "0",
														backgroundColor: "#369678",
														color: "white",
														padding: "5px 10px",
														borderRadius: "50px",
														fontSize: "1rem",
														}}
														>
														{ItemsInCart}
													</div></Menu.Item>}

									{/*shop.categories.map(category => {
					return <Menu.Item as={Link} className="dib f6 pr2" key={category.map_id} to={`/collection/${category.map_id}/`}><div><img width="40" src={category.img_src}/></div>
					<div>{category.desc.des}</div></Menu.Item>
									})*/}
									<Responsive maxWidth={768}><Menu.Item onClick={app.sidebarLeft.toggle.dispatch}><Icon
										name="bars"/></Menu.Item>
									</Responsive>
								</MenuBySlug>
								{/*{!shop.session && <div><Link to="/login">Anmelden</Link> oder <Link to="/customer_registration">Registrieren</Link></div>}*/}
							</div>

							<div className="tc pb3">
								<div className="logo--shop block">
								</div>
							</div>
							{/*<Menu slug="menu-en"/>*/}
						</Container>
					</div>
				</OnOffset>
				{/*<MenuUtility list={list}/>*/}
				<div className="container-fluid navigation-bar">
					{/*<MenuCustomCategories/>*/}
				</div>
			</div>
		)
	}
}

const MiniHeaderMobile = () => <div
  className="mini-header z-9 fixed top-0 left-0 right-0  animate  fadeInDown" style={{backgroundColor:"#f3f0e7"}}>
	  <div className="MobileHeader ">
		<div className="pa1 ph2 ph2-ns pt3-ns pb3-ns">
		  <div className="flex flex-row justify-between items-center ">
			<div className={"w-70 flex flex-row justify-start pr4 pb3 pt3"}>
			  <Button className="ButtonFooter" as="a"><Icon className="IconCss" onClick={app.sidebarLeft.toggle.dispatch} name="big bars" /></Button>
			  {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&
			  <Button className="ButtonFooter" as={Link} to={`/account/?referrer=${document.location.pathname}`}><Icon className="IconCss" name="big user circle" /></Button>}
			  {((!shop.session) || (shop.session && shop.session.shopuser && shop.session.shopuser.guest)) &&
			  <Button className="ButtonFooter" as={Link} to={`/login/?referrer=${document.location.pathname}`}><Icon className="IconCss"  name="big user circle" /></Button>}
			</div>
			
			<div className={"w-100 flex flex-row items-center justify-center"}>
			  <Image as={Link} to={"/"} src={"/Logo_JohannesLucht_gruen.png"} />
			</div>
			
			<div className={"w-70 flex flex-row justify-end items-center pr4 pb3 pt3"}>
			  {/*<Search />*/}
			  <Button className="ButtonFooter" as={Link} to={`/search/?referrer=${document.location.pathname}`}><Icon  className="IconCss" name="big search " /></Button>
			  <Button className="ButtonFooter" as={Link} to={shop.session ? `/checkout/?referrer=${document.location.pathname}` : `/login/?referrer=${document.location.pathname}`}><Icon className="IconCss" name="big shopping cart" /></Button>
			</div>
		  </div>
		</div>
	  </div>
</div>


const MiniHeader = () => <div style={{backgroundColor:"#f3f0e7"}} className="mini-header z-9 fixed top-0 left-0 right-0 animate  fadeInDown">
	<div className="ph2 pa3 pr5">
		<MenuBySlug slug={"header"}
								key={"mini-header-main"}
								secondary
								borderless>

									<Menu.Item
									position="right"
										as={Link}
										to="/search/"><Icon name="big grey search"/></Menu.Item>
								{shop.session && <Menu.Item className="relative"
										as={Link}
										to="/checkout/"><Icon name="big grey shopping cart"/></Menu.Item>}
			
		</MenuBySlug>
	</div>
</div>


class OnOffset extends Component {

	state = {
		passed: false
	}

	componentDidMount() {
		window.addEventListener( "scroll", this.handleScroll )
		this.handleScroll()
	}

	componentWillUnmount() {
		window.removeEventListener( "scroll", this.handleScroll )
	}

	handleScroll = () => {
		let {passed} = this.state
		let {pageYOffset} = window
		if ( pageYOffset > this.props.offset ) {
			if ( !passed ) {
				this.setState( {passed: true} )
				this.props.onPassed && this.props.onPassed()
			}
		} else {
			if ( passed ) {
				this.setState( {passed: false} )
				this.props.onPassedReverse && this.props.onPassedReverse()
			}
		}
	}

	render() {
		return this.props.children || null
	}
}





// WEBPACK FOOTER //
// ./src/theme/lucht-test/components/Header/Header.js